import React from 'react'
import { useTranslation } from 'react-i18next'

import { Body2 } from '@ui/Typography'
import { Accordion } from '@ui/components/Accordion'
import { WavyBillIcon } from '@ui/icons/WavyBill.icon'

import { isCryptoDepositInfoPaymentProvider } from '@model/PaymentProviderId'

import { Box } from '@shared/components/Box'
import { Notice } from '@shared/components/Notice'

import styles from './CryptoDepositInfo.module.scss'

interface CryptoDepositInfoProps {
  paymentProviderId?: string
}

export const CryptoDepositInfo: React.FC<CryptoDepositInfoProps> = ({ paymentProviderId }) => {
  const { t } = useTranslation()
  const isCryptoDepositInfoVisible = isCryptoDepositInfoPaymentProvider(paymentProviderId)

  if (!isCryptoDepositInfoVisible) {
    return null
  }

  const cryptoGuidelineItems = [
    t('Wallet.Payments are accepted only in the listed cryptocurrencies'),
    t('Wallet.It is mandatory to complete your payment within the timeframe'),
    t('Wallet.Deposit the exact amount initially selected'),
  ]

  return (
    <Box flex direction='column' gap='x16' fullWidth>
      <Accordion title={t('Wallet.Guidelines & Important Notes')} fullWidth>
        <ul className={styles.guidelinesList}>
          {cryptoGuidelineItems.map((guideline) => (
            <li key={guideline}>
              <Body2 color='text-med-em'>{guideline}</Body2>
            </li>
          ))}
        </ul>
      </Accordion>
      <Notice id='crypto-fee-info' type='info' icon={WavyBillIcon} message={t('Crypto info')} />
    </Box>
  )
}
